import {afterNextRender} from "@angular/core";

export class AbstractOauthService {
  module: any;
  constructor() {
    afterNextRender(async () => {
      this.module = await import('@capgo/capacitor-social-login');
    });
  }
  public async logoutProvider(provider: 'google' | 'facebook'): Promise<void> {
    try {
      if (!this.module?.SocialLogin) {
        return;
      }
      const {isLoggedIn} = await this.module.SocialLogin.isLoggedIn({provider});
      if (isLoggedIn) {
        await this.module.SocialLogin.logout({provider});
      }
    } catch (e) {
      console.warn('OAuth logout skipped for provider', provider, e);
    }
  }
  public logout(): void {
    (async () => {
      for (const e  of ['google', 'facebook']) {
        await this.logoutProvider(e as 'google' | 'facebook');
      }
    })();
  }
}
